import { useState } from "react";
import Terms from "../../components/Terms/Terms";
import "./home.css";
import "bootstrap/dist/css/bootstrap.min.css";

const Home = () => {
  const [showTerms, setShowTerms] = useState(true);

  const handleAcceptTerms = () => {
    setShowTerms(false);
  };

  return (
    <div className="container py-2 home-page">
      <div className="row justify-content-center">
        <div className="col-lg-10">
          <h1 className="title">Bem-vindo ao Programa Meritocracia Sindical</h1>
          <p className="intro-text">
            O <strong>Programa Meritocracia Sindical</strong> foi criado com o
            intuito de contribuir com o desenvolvimento dos sindicatos para
            melhor atender as indústrias, incentivar a adoção de ferramentas
            estratégicas de gestão, contribuir com a sustentabilidade
            financeira, promover o associativismo, bem como a cultura da
            governança no ambiente sindical.
          </p>
        </div>
      </div>

      <div className="row justify-content-center mt-4">
        <div className="col-lg-10">
          <div className="card objectives-card">
            <h2 className="section-title text-center">Objetivos</h2>
            <ul className="objectives-list">
              <li>✅ Sindicatos mais fortes, proativos e representativos;</li>
              <li>✅ Sindicatos autossustentáveis;</li>
              <li>✅ Sindicatos mais transparentes e regulares;</li>
              <li>
                ✅ Aumento do associativismo e percepção de valor pelos
                associados;
              </li>
              <li>
                ✅ Melhoria do ambiente de negócios e da competitividade das
                indústrias de Minas Gerais.
              </li>
            </ul>
          </div>
        </div>
      </div>

      <Terms show={showTerms} handleAccept={handleAcceptTerms} />
    </div>
  );
};

export default Home;
